import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Activity, RefreshCw } from "lucide-react";

const TYPE_META = {
    inquiry: { label: "Anfrage", color: "text-[#C88A45]" },
    review: { label: "Bewertung", color: "text-[#C88A45]" },
    review_deleted: { label: "Bewertung entfernt", color: "text-red-400" },
    booking: { label: "Fuhre", color: "text-[#7A9B5A]" },
    availability: { label: "Kalender", color: "text-[#7A9B5A]" },
    prices: { label: "Preise", color: "text-[#D9A441]" },
    settings: { label: "Einstellung", color: "text-[#D9A441]" },
    login_success: { label: "Login", color: "text-[#7A9B5A]" },
    login_failed: { label: "Login-Fehler", color: "text-red-400" },
    login_locked: { label: "Login-Sperre", color: "text-red-400" },
};

export const ActivityAdmin = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(() => {
        api.get("/admin/events").then((r) => setEvents(r.data)).catch(() => {}).finally(() => setLoading(false));
    }, []);
    useEffect(() => {
        load();
        const t = setInterval(load, 15000);
        return () => clearInterval(t);
    }, [load]);

    return (
        <div data-testid="admin-activity">
            <div className="mb-6 flex items-center justify-between">
                <p className="flex items-center gap-2 text-sm text-[#9C917D]">
                    <Activity size={15} className="text-[#C88A45]" /> Live-Feed — aktualisiert sich alle 15 Sekunden automatisch.
                </p>
                <button data-testid="activity-refresh" onClick={load} className="flex items-center gap-2 rounded-full border border-[#2E2517] px-4 py-1.5 text-xs text-[#9C917D] transition-colors hover:text-[#EDE6DA]">
                    <RefreshCw size={13} /> Aktualisieren
                </button>
            </div>
            {loading && <p className="text-sm text-[#9C917D]">Lade Aktivitäten …</p>}
            {!loading && events.length === 0 && <p className="text-sm text-[#9C917D]">Noch keine Aktivitäten.</p>}
            <div className="divide-y divide-[#2E2517] rounded border border-[#2E2517] bg-[#1B150E]">
                {events.map((e) => (
                    <div key={e.id} className="flex flex-wrap items-baseline justify-between gap-2 px-5 py-3" data-testid={`event-${e.id}`}>
                        <p className="text-sm text-[#D9D2C4]">
                            <span className={`mr-3 text-xs font-semibold uppercase ${(TYPE_META[e.type] || {}).color || "text-[#9C917D]"}`}>
                                {(TYPE_META[e.type] || {}).label || e.type}
                            </span>
                            {e.text}
                        </p>
                        <span className="text-xs text-[#9C917D]">{new Date(e.created_at).toLocaleString("de-DE")}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
